import React, { useRef, useEffect, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

interface SignaturePadProps {
    onSignature: (signature: string) => void;
    clear: boolean;
    isSigned: boolean;
    consent: boolean;
    setConsent: (value: boolean) => void;  // Ajouter setConsent ici
    signature?: string;
    readOnly: boolean
}

const SignaturePad: React.FC<SignaturePadProps> = ({ onSignature, clear, isSigned, consent, setConsent, signature, readOnly }) => {
    const sigCanvas = useRef<SignatureCanvas>(null);
    const [isCanvasEmpty, setIsCanvasEmpty] = useState<boolean>(true);

    useEffect(() => {
        if (clear && sigCanvas.current) {
            sigCanvas.current.clear();
            setIsCanvasEmpty(true);
        }
    }, [clear]);

    useEffect(() => {
        if (signature && sigCanvas.current) {
            sigCanvas.current.fromDataURL(signature);
            setIsCanvasEmpty(false);
        }
    }, [signature]);

    const checkCanvasEmpty = () => {
        if (sigCanvas.current) {
            setIsCanvasEmpty(sigCanvas.current.isEmpty());
        }
    };

    const handleSave = () => {
        if (consent && !isCanvasEmpty) {
            if (sigCanvas.current) {
                const newSignature = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
                const base64Only = newSignature.split(',')[1];
                onSignature(base64Only); 
            }
        } else if (!consent) {
            alert("Vous devez accepter les conditions avant de sauvegarder votre signature.");
        } else if (isCanvasEmpty) {
            alert("Veuillez fournir une signature avant de sauvegarder.");
        }
    };
    useEffect(() => {
        if (sigCanvas.current) {
            const canvas = sigCanvas.current.getCanvas();
            const ctx = canvas.getContext("2d");

            if (ctx) {
                const ratio = window.devicePixelRatio || 1;
                canvas.width = canvas.offsetWidth * ratio;
                canvas.height = canvas.offsetHeight * ratio;
                ctx.scale(ratio, ratio); // Ajuste l'échelle du dessin
            }
        }
    }, []);

    const handleConsentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConsent(e.target.checked);  // Mise à jour de consentement depuis le parent
    };

    return (
        <div>
            {!isSigned && (
                <>

                    <SignatureCanvas
                        ref={sigCanvas}
                        penColor="black"
                        canvasProps={{ className: 'sigCanvas' }}
                        onEnd={checkCanvasEmpty}
                    />

                    <div>
                        <input
                            type="checkbox"
                            id="consent"
                            checked={consent}
                            onChange={handleConsentChange}
                        />
                        <label htmlFor="consent">J'accepte l'utilisation de la signature électronique.</label>
                    </div>
                    <div className='containerButtonSignature'>
                        <button className='buttonSignature' onClick={handleSave} disabled={isCanvasEmpty || !consent}>
                            Sauvegarder
                        </button>
                        <button className='buttonSignature' onClick={() => { sigCanvas.current?.clear(); setIsCanvasEmpty(true); }}>
                            Effacer
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default SignaturePad;
